export const getAllTaxes =  (state) => state.allTaxes
export const getTaxes =  (state) => state.taxes
export const getTaxesMeta = (state) => state.metaData
export const getTaxTypes = (state) => state.taxTypes




